import Assets from 'imports/assets.import';
import MenuItem from 'common_components/ui/menu_item/menu_item.ui';
import ProfileAvatar from 'common_components/ui/profile_avatar/profile_avatar.ui';
import { STRINGS } from 'constants/strings.constant';
import { NavBarProfilePopupProps } from 'interfaces/nav_bar.interface';
import './nav_bar_profile_popup.component.scss';

const NavBarProfilePopup = (props: NavBarProfilePopupProps) => {
  const copy = STRINGS.navBar.profilePopup;

  return (
    <div className="nav_bar_profile_popup">
      <div className="nav_bar_profile_popup_header">
        <div className="nav_bar_profile_popup_header_avatar">
          <ProfileAvatar pictureUrl={props.pictureUrl} name={props.name} />
        </div>
        <div className="nav_bar_profile_popup_header_text">
          <div className="nav_bar_profile_popup_header_name">{props.name}</div>
          <div className="nav_bar_profile_popup_header_email">{props.email}</div>
        </div>
      </div>
      <div className="nav_bar_profile_popup_divider" />
      <div role="menu" className="nav_bar_profile_popup_items">
        {!props.isAdmin && (
          <MenuItem icon={Assets.upgrade} label={copy.pricing} onClick={() => props.onNavigate('/upgrade-plan')} />
        )}
        <MenuItem
          icon={Assets.profile}
          label={copy.accountSettings}
          onClick={() => props.onNavigate('/account-settings')}
        />
        {!props.isAdmin && (
          <MenuItem icon={Assets.info_circle_menu} label={copy.support} onClick={() => props.onNavigate('/support')} />
        )}
        <div className="nav_bar_profile_popup_divider" />
        <MenuItem icon={Assets.logout} label={copy.logout} onClick={props.onLogout} isDanger />
      </div>
    </div>
  );
};

export default NavBarProfilePopup;
